<msd-segmented-navigation-item *ngFor="let item of items"
                               [name]="item.name"
                               [itemsCount]="item.itemsCount"
                               [isActive]="selectedId === item.id"
                               [icon]="selectedId === item.id ? item.icon : undefined"
                               [class.desktop]="item.onlyDesktop"
                               (click)="onNavigationItemClick(item.id)"
></msd-segmented-navigation-item>
